/* eslint-disable no-bitwise */
import { Color } from "three";
import { GRID_SIZE } from "../constants";

const gridBase = 2 ** GRID_SIZE;
const redBase = 2 ** 16;
const greenBase = 2 ** 8;
const colorBase = 2 ** 8;

function devectorize(base, arr, i = 0, result = 0) {
  const end = arr.length - 1;
  if (i > end) return result;
  const current = arr[i] * base ** (end - i);
  return devectorize(base, arr, i + 1, current + result);
}

// >>> => move x bits to the left (on unsigned 32 bit int). / division by 2**x
function vectorizeGenomicPos(x, y) {
  const base = x >>> GRID_SIZE;
  const rest = x - base * gridBase;
  return [base, rest, y];
}

function vectorizeGenomicPosInline(arr, x) {
  const base = x >>> GRID_SIZE;
  const rest = x - base * gridBase;
  arr[0] = base;
  arr[1] = rest;
}

function vectorizeGenomicPosInd(arr, ind, x) {
  const base = x >>> GRID_SIZE;
  const rest = x - base * gridBase;
  arr[ind] = base;
  arr[ind + 1] = rest;
}

// >>> => move x bits to the left (on unsigned 32 bit int). / divisiion by 2**x
function vectorizeRGB(arr, itemInd, repeat = 1) {
  const red = itemInd >>> 16;
  const redRemain = itemInd - redBase * red;
  const green = redRemain >>> 8;
  const blue = redRemain - greenBase * green;

  for (let x = 0; x < repeat; x++) {
    const i = itemInd * 3 * repeat + 3 * x;
    arr[i + 0] = red / (colorBase - 1);
    arr[i + 1] = green / (colorBase - 1);
    arr[i + 2] = blue / (colorBase - 1);
  }
}

function vectorizeCSSRgbString(str) {
  const threeColor = new Color(str);
  threeColor.convertLinearToSRGB();
  return [threeColor.r, threeColor.g, threeColor.b];
}

function devectorizeRGB(rgb) {
  return devectorize(colorBase, rgb);
}

export {
  vectorizeGenomicPosInd,
  vectorizeGenomicPosInline,
  devectorize,
  vectorizeGenomicPos,
  vectorizeRGB,
  devectorizeRGB,
  vectorizeCSSRgbString,
};
